import { type PropsWithChildren, useEffect, useState } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { createCustomUIEvent, CustomUIEventEnum } from '@jsmdg/ui-event';
import { type RedemptionInformation } from '../../../shared/types';
import { RedemptionContext } from '../../context/RedemptionContext';
import { useCartContext } from '../../hooks/useCartContext';
import { type HeaderContext } from '../../types';

const RedemptionContextProvider = ({ children }: PropsWithChildren): JSX.Element => {
    const { redemptionInformation: initialRedemptionInformation } =
        useFragmentContext<HeaderContext>();
    const [redemptionInformation, setRedemptionInformation] = useState<RedemptionInformation>(
        initialRedemptionInformation,
    );
    const cart = useCartContext();

    useEffect(() => {
        if (cart?.vouchers && cart?.vouchersTotal) {
            setRedemptionInformation(prev => ({
                ...prev,
                vouchers: cart.vouchers,
                vouchersTotal: cart.vouchersTotal,
                vouchersCount: cart.vouchers.length,
            }));

            document.dispatchEvent(
                createCustomUIEvent(CustomUIEventEnum.AddVoucher, {
                    detail: {
                        amount: Number(cart.vouchersTotal.amount ?? 0),
                        currencyCode: cart.vouchersTotal.currencyCode ?? '',
                        cartProductIds: cart.itemsProductIds || [],
                    },
                }),
            );
        }
    }, [cart]);

    return (
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <RedemptionContext.Provider value={{ redemptionInformation, setRedemptionInformation }}>
            {children}
        </RedemptionContext.Provider>
    );
};

export { RedemptionContextProvider };
